import { useEffect, useState } from "react";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

import { useParams } from "react-router";
import { Link } from "react-router-dom";
import OrderApi from "../../api/orderAPI";
import AuthLayout from "../../components/AuthLayout/AuthLayout";
import format from "../../helpers/format";

dayjs.extend(relativeTime);

const OrderDetail = () => {
  const { id } = useParams();
  const [order, setOrder] = useState({});
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      await OrderApi.getOrderDetail(id)
        .then((res) => {
          setOrder(res);
        })

      setLoading(false);
    })();
  }, [id]);

  return (
    <AuthLayout>
      <header
        className={"d-flex justify-content-between align-items-center mb-4"}
      >
        <h1>Order</h1>
        <Link className={"btn btn-primary"} to={`/orders/edit/${order._id}`}>
          Edit
        </Link>
      </header>
      {loading ? (
        <p className="text-center">Loading...</p>
      ) : order && Object.keys(order).length > 0 ? (
        <div className="row mb-5">
          <div className="col-md-6">
            <dl className="row">
            <dt className="col-sm-3 fw-normal text-muted mb-2">Order ID</dt>
            <dd className="col-sm-9 mb-2"><span>{order._id}</span></dd>
            <dt className="col-sm-3 fw-normal text-muted mb-2">Email</dt>
            <dd className="col-sm-9 mb-2"><span>{order.email}</span></dd>
            <dt className="col-sm-3 fw-normal text-muted mb-2">Customer ID</dt>
            <dd className="col-sm-9 mb-2">
              {order.customerId ? (
                <Link to={`/users/view/${order.customerId}`}>{order.customerId}</Link>
              ) : (
                <span className="text-muted">N/A</span>
              )}
            </dd>
            
            <dt className="col-sm-3 fw-normal text-muted mb-2">Item ID</dt>
            <dd className="col-sm-9 mb-2">
              {order.itemId ? (
                <Link to={`/resources/view/${order.itemId}`}>{order.itemId}</Link>
              ) : (
                <span className="text-muted">N/A</span>
              )}
            </dd>
            <dt className="col-sm-3 fw-normal text-muted mb-2">Price</dt>
            <dd className="col-sm-9 mb-2">{format.formatCurrency(order.price)}</dd>
            <dt className="col-sm-3 fw-normal text-muted mb-2">Quantity</dt>
            <dd className="col-sm-9 mb-2">{order.quantity}</dd>
            <dt className="col-sm-3 fw-normal text-muted mb-2">Subtotal</dt>
            <dd className="col-sm-9 mb-2">{format.formatCurrency(order.subtotal)}</dd>
            <dt className="col-sm-3 fw-normal text-muted mb-2">Total</dt>
            <dd className="col-sm-9 mb-2">{format.formatCurrency(order.total)}</dd>
            <dt className="col-sm-3 fw-normal text-muted mb-2">Invoice Number</dt>
            <dd className="col-sm-9 mb-2">{order.invoiceNumber || <span className="text-muted">N/A</span>}</dd>
            </dl>
          </div>
          <div className="col-md-6">
            <dl className="row">
              <dt className="col-sm-3 fw-normal text-muted mb-2">Payment ID</dt>
            <dd className="col-sm-9 mb-2">{order.paymentId || <span className="text-muted">N/A</span>}</dd>
            <dt className="col-sm-3 fw-normal text-muted mb-2">Payment Status</dt>
            <dd className="col-sm-9 mb-2">{format.formatPaymentStatus(order.paymentStatus)}</dd>
            <dt className="col-sm-3 fw-normal text-muted mb-2">Order Type</dt>
            <dd className="col-sm-9 mb-2 text-capitalize">
              <span className={`badge rounded-pill bg-${order.orderType === 'single' ? 'primary' : 'info'} bg-opacity-10 text-${order.orderType === 'single' ? 'primary' : 'info'} fw-normal py-1 px-2`}>
                {order.orderType}
              </span>
            </dd>
            <dt className="col-sm-3 fw-normal text-muted mb-2">Order Status</dt>
            <dd className="col-sm-9 mb-2">{format.formatOrderStatus(order.orderStatus?.status)}</dd>
            <dt className="col-sm-3 fw-normal text-muted mb-2">Created At</dt>
            <dd className="col-sm-9 mb-2">
              {dayjs(order.created_at).format("YYYY-MM-DD HH:mm:ss")}
              <span className="ms-2 badge rounded-pill bg-secondary bg-opacity-10 text-secondary fw-normal py-1 px-2">
                <i className="bi bi-clock me-1"></i>
                <span className="">{dayjs(order.created_at).fromNow()}</span>
              </span>
            </dd>
            <dt className="col-sm-3 fw-normal text-muted mb-2">Valid Until</dt>
            <dd className="col-sm-9 mb-2">
              {order.valid_until ? (
                <>
                  {dayjs(order.valid_until).format("YYYY-MM-DD HH:mm:ss")}
                  <span className="ms-2 badge rounded-pill bg-secondary bg-opacity-10 text-secondary fw-normal py-1 px-2">
                    <i className="bi bi-clock me-1"></i>
                    <span className="">{dayjs(order.valid_until).fromNow()}</span>
                  </span>
                </>
              ) : (
                <span className="text-muted">N/A</span>
              )}
            </dd>
            <dt className="col-sm-3 fw-normal text-muted mb-2">Download URL</dt>
            <dd className="col-sm-9 mb-2">{order.downloadUrl || <span className="text-muted">N/A</span>}</dd>
            <dt className="col-sm-3 fw-normal text-muted mb-2">Access Grant</dt>
            <dd className="col-sm-9 mb-2">{order.accessGrant || <span className="text-muted">N/A</span>}</dd>
            
            {order.updated_at && (
              <>
                <dt className="col-sm-3 fw-normal text-muted mb-2">Updated At</dt>
                <dd className="col-sm-9 mb-2">
                  {dayjs(order.updated_at).format("YYYY-MM-DD HH:mm:ss")}
                  <span className="ms-2 badge rounded-pill bg-secondary bg-opacity-10 text-secondary fw-normal py-1 px-2">
                    <i className="bi bi-clock me-1"></i>
                    <span className="">{dayjs(order.updated_at).fromNow()}</span>
                  </span>
                </dd>
              </>
            )}
          </dl>
          </div>
          
        </div>
      ) : (
        <p>{"Not found"}</p>
      )}
    </AuthLayout>
  );
};

export default OrderDetail;
